import { render, staticRenderFns } from "./pipe-table.vue?vue&type=template&id=6bd5193a"
import script from "./pipe-table.vue?vue&type=script&lang=js"
export * from "./pipe-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports